import { lazy } from "react";
function promiseRetry(fn, retriesLeft = 5, interval = 1e3, args) {
  return new Promise((resolve, reject) => {
    fn.apply(this, args).then(resolve).catch((error) => {
      setTimeout(() => {
        if (retriesLeft === 1) {
          reject(error);
          return;
        }
        promiseRetry(fn, retriesLeft - 1, interval, args).then(
          resolve,
          reject
        );
      }, interval);
    });
  });
}
function lazyWithRetry(factory) {
  return lazy(() => promiseRetry(factory));
}
function lazyImport(factory, name) {
  return /* @__PURE__ */ Object.create({
    [name]: lazyWithRetry(() => factory().then((module) => ({ default: module[name] })))
  });
}
export {
  lazyImport,
  lazyWithRetry,
  promiseRetry
};
